import { ArrowLongRightIcon } from "@heroicons/react/24/solid";
import clsx from "clsx";
import Link from "next/link";
import React from "react";
import { NAV_LABELS } from "~/content/Labels";
import { ROUTES } from "~/content/Routes";
import { Building, Handshake, House, KeyRound, Landmark } from "lucide-react";

interface SquareButtonProps {
  key: string;
  icon: React.ComponentType<{ className?: string }>;
  label: string;
  href: string;
  className?: string;
}

const buttonsData = [
  {
    icon: Building,
    label: NAV_LABELS.FOR_PROPERTY_MANAGERS,
    href: ROUTES.PROPERTY_MANAGERS,
  },
  {
    icon: KeyRound,
    label: NAV_LABELS.FOR_LANDLORDS,
    href: ROUTES.LANDLORDS,
  },
  {
    icon: Landmark,
    label: NAV_LABELS.FOR_BUILDING_MANAGERS,
    href: ROUTES.BUILDING_MANAGERS,
  },
  {
    icon: House,
    label: NAV_LABELS.FOR_HOMEOWNERS,
    href: ROUTES.HOMEOWNERS,
  },
  {
    icon: Handshake,
    label: NAV_LABELS.FOR_REAL_ESTATE,
    href: ROUTES.REAL_ESTATE,
  },
];

const SquareButton: React.FC<SquareButtonProps> = ({
  icon: IconComponent,
  label,
  href,
  className,
}) => {
  return (
    <Link
      href={href}
      className={clsx(
        "group relative flex h-36 w-full items-center justify-center overflow-hidden rounded border border-[#E5E7EB] bg-white text-[#0C1F3F] shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-[#00A87A] hover:bg-[#E8FAF4] hover:shadow-md sm:h-44",
        className
      )}
    >
      <IconComponent
        className={clsx(
          "absolute left-1/2 top-4 h-10 w-10 -translate-x-1/2 transform text-[#5C6370] transition-colors duration-300 group-hover:text-[#00A87A] sm:h-12 sm:w-12",
          className
        )}
      />
      <div className="absolute mt-6 flex flex-col items-center justify-center px-2">
        <span className="text-sm text-[#0C1F3F] transition-colors duration-300 group-hover:text-[#0C1F3F]">
          {label}
        </span>
      </div>
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 pb-2 sm:pb-4">
        <ArrowLongRightIcon
          className={clsx(
            "h-5 w-5 text-[#5C6370] transition-all duration-300 group-hover:translate-x-1.5 group-hover:text-[#00A87A] sm:h-6 sm:w-6",
            className
          )}
        />
      </div>
    </Link>
  );
};

type ButtonItem = {
  icon: React.ComponentType<{ className?: string }>;
  label: string;
  href: string;
};

const SolutionSelector: React.FC<{ items?: ButtonItem[]; gridClassName?: string }> = ({
  items,
  gridClassName,
}) => {
  const data = items ?? buttonsData;
  return (
    <div
      className={clsx(
        "grid w-full justify-items-center text-center",
        gridClassName ?? "grid-cols-2 xl:grid-cols-5 gap-8 mb-10"
      )}
    >
      {data.map((button) => (
        <SquareButton
          key={button.href}
          icon={button.icon}
          label={button.label}
          href={button.href}
        />
      ))}
    </div>
  );
};

export default SolutionSelector;
